export default function SvgPresentationChart2(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M12 15.996v5m6 0l-3.951-3.293c-.73-.608-1.094-.911-1.5-1.027a1.999 1.999 0 00-1.098 0c-.406.116-.77.42-1.5 1.027L6 20.996m2-10v1m4-3v3m4-5v5m6-9H2m1 0h18v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.31c-.642.328-1.482.328-3.162.328H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 13.716 3 12.876 3 11.196v-8.2z"
            ></path>
        </svg>
    )
}